import craneServiceSelected from "../../../images/craneServiceSelected.svg";
import escortServiceSelected from "../../../images/escortServiceSelected.svg";
import escortServiceUnselected from "../../../images/escortServiceUnselected.svg";
import craneExtendedUnselected from "../../../images/craneExtendedUnselected.svg";
import craneExtendedSelected from "../../../images/craneExtendedSelected.svg";
import bikeServiceUnselected from "../../../images/bikeServiceUnselected.svg";
import batteryPurchaseUnselected from "../../../images/batteryPurchaseUnselected.svg";
import gasServiceUnselected from "../../../images/gasServiceUnselected.svg";
import tireServiceUnselected from "../../../images/tireServiceUnselected.svg";
import craneServiceUnselected from "../../../images/craneServiceUnselected.svg";
import bikeServiceSelected from "../../../images/bikeServiceSelected.svg";
import segViajeUnselected from "../../../images/segViajeUnselected.svg";
import segViajeSelected from "../../../images/segViajeSelected.svg";
import batteryPurchaseSelected from "../../../images/batteryPurchaseSelected.svg";
import gruaExtendidaUnselected from "../../../images/gruaExtendidaUnselected.svg";
import gasServiceSelected from "../../../images/gasServiceSelected.svg";
import tireServiceSelected from "../../../images/tireServiceSelected.svg";
import batteryServiceUnselected from "../../../images/batteryServiceUnselected.svg";
import batteryServiceSelected from "../../../images/batteryServiceSelected.svg";
import verificacionDomicilioSelected from "../../../images/verificacionDomicilioSelected.svg";
import verificacionDomicilioUnselected from "../../../images/verificacionDomicilioUnselected.svg";
import locksmithServiceSelected from "../../../images/locksmithServiceSelected.svg";
import locksmithServiceUnselected from "../../../images/locksmithServiceUnselected.svg";

import {
  afiliatedServices,
  particularServices,
} from "../../../assets/helpers/options";
import { capitalize } from "../../../assets/helpers/funciones";

import "./Incidence.scss";

export const ServiceButton = (props) => {
  const { service, selectService } = props;

  let src = "";

  if (
    [afiliatedServices.crane, particularServices.crane].includes(service?.code)
  ) {
    service.selected
      ? (src = craneServiceSelected)
      : (src = craneServiceUnselected);
  }
  if (
    [afiliatedServices.ESCORT, particularServices.ESCORT].includes(service?.code)
  ) {
    service.selected
      ? (src = escortServiceSelected)
      : (src = escortServiceUnselected);
  }
  if ([afiliatedServices.gas, particularServices.gas].includes(service?.code)) {
    service.selected
      ? (src = gasServiceSelected)
      : (src = gasServiceUnselected);
  }
  if (
    [
      afiliatedServices.tire,
      particularServices.tire1,
      particularServices.tire2,
    ].includes(service?.code)
  ) {
    service.selected
      ? (src = tireServiceSelected)
      : (src = tireServiceUnselected);
  }
  if (
    [afiliatedServices.battery, particularServices.battery].includes(
      service?.code
    )
  ) {
    service.selected
      ? (src = batteryServiceSelected)
      : (src = batteryServiceUnselected);
  }
  if (
    [
      afiliatedServices.accompaniment,
      particularServices.accompaniment,
    ].includes(service?.code)
  ) {
    service.selected
      ? (src = bikeServiceSelected)
      : (src = bikeServiceUnselected);
  }
  if ([afiliatedServices.craneExtended].includes(service?.code)) {
    service.selected
      ? (src = craneExtendedSelected)
      : (src = gruaExtendidaUnselected);
  }

  if ([afiliatedServices.BATT_SALE, particularServices.BATT_SALE_PART].includes(service?.code)) {
    service.selected
      ? (src = batteryPurchaseSelected)
      : (src = batteryPurchaseUnselected);
  }

  if ([afiliatedServices.SEG_VIAJE].includes(service?.code)) {
    service.selected ? (src = segViajeSelected) : (src = segViajeUnselected);
  }

  if ([particularServices.VERIFICACION_DOMICILIO].includes(service?.code)) {
    service.selected
      ? (src = verificacionDomicilioSelected)
      : (src = verificacionDomicilioUnselected);
  }

  if ([afiliatedServices.LOCKSMITH].includes(service?.code)) {
    service.selected
      ? (src = locksmithServiceSelected)
      : (src = locksmithServiceUnselected);
  }

  return (
    <div className="service-button-container">
      <h6>{capitalize(service?.product)}</h6>
      <img src={src} onClick={() => selectService(service)} />
    </div>
  );
};

export const SMSServiceLogo = (props) => {
  const { service, action, grua } = props;
  let src = "";
  if (
    [afiliatedServices.crane, particularServices.crane].includes(service) ||
    grua
  ) {
    src = craneServiceUnselected;
  }
  if (
    [afiliatedServices.ESCORT, particularServices.ESCORT].includes(service) ||
    grua
  ) {
    src = escortServiceUnselected;
  }
  if ([afiliatedServices.craneExtended].includes(service)) {
    src = craneExtendedUnselected;
  }
  if ([afiliatedServices.gas, particularServices.gas].includes(service)) {
    src = gasServiceUnselected;
  }
  if (
    [
      afiliatedServices.tire,
      particularServices.tire1,
      particularServices.tire2,
    ].includes(service)
  ) {
    src = tireServiceUnselected;
  }
  if (
    [afiliatedServices.battery, particularServices.battery].includes(service)
  ) {
    src = batteryServiceUnselected;
  }
  if (
    [
      afiliatedServices.accompaniment,
      particularServices.accompaniment,
    ].includes(service)
  ) {
    src = bikeServiceUnselected;
  }
  if (
    [
      afiliatedServices.BATT_SALE,
      particularServices.BATT_SALE_PART,
    ].includes(service)
  ) {
    src = batteryPurchaseUnselected;
  }
  if ([particularServices.VERIFICACION_DOMICILIO].includes(service)) {
    src = verificacionDomicilioUnselected;
  }
  if ([afiliatedServices.LOCKSMITH].includes(service)) {
    src = locksmithServiceUnselected;
  }
  return <img onClick={action} className="gasLogo" src={src} />;
};

export const EstimatedTime = (props) => {
  const { service } = props;

  // Mensaje para las gruas
  if (
    [afiliatedServices.crane, particularServices.crane].includes(service) &&
    service
  ) {
    return (
      <>
        <br /> <b>Tiempo estimado:</b> 40 min
      </>
    );
  }
  if (
    ![afiliatedServices.crane, particularServices.crane].includes(service) &&
    service
  ) {
    return (
      <>
        <br /> <b>Tiempo estimado: </b>25 min
      </>
    );
  } else return null;
};
